import posthog from "posthog-js";

let initialized = false;

export const initPostHog = (): void => {
  if (initialized) return;
  if (typeof window === "undefined") return;

  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://eu.i.posthog.com";

  if (!key) return; // no-op when unconfigured (dev/preview)

  posthog.init(key, {
    api_host: host,
    person_profiles: "identified_only",
    capture_pageview: false, // SPA — driven from usePageTracking
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
    },
  });
  posthog.register({ environment: import.meta.env.MODE });
  initialized = true;
};

const isLoaded = (): boolean => {
  // posthog.__loaded is set after init resolves
  return initialized && typeof window !== "undefined" && !!(posthog as any).__loaded;
};

export const capture = (event: string, props?: Record<string, unknown>): void => {
  if (!isLoaded()) return;
  try {
    posthog.capture(event, props);
  } catch (e) {
    console.error("[PostHog] capture failed:", e);
  }
};

export const identify = (
  distinctId: string,
  props?: Record<string, unknown>,
): void => {
  if (!isLoaded()) return;
  try {
    posthog.identify(distinctId, props);
  } catch (e) {
    console.error("[PostHog] identify failed:", e);
  }
};

export const reset = (): void => {
  if (!isLoaded()) return;
  try {
    posthog.reset();
  } catch (e) {
    console.error("[PostHog] reset failed:", e);
  }
};

export { posthog };
